import type { GetSurveysParams, GetSurveysResponse, SurveyStatsParams, SurveyStatsResponse } from '../types/survey';
import baseApi from './baseApi';

const surveysApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSurveys: build.query({
      query: (params: GetSurveysParams) => {
        const searchParams = new URLSearchParams();

        if (params.businessUnitId) {
          searchParams.append('businessUnitId', params.businessUnitId.toString());
        }
        if (params.startDate) {
          searchParams.append('startDate', params.startDate);
        }
        if (params.endDate) {
          searchParams.append('endDate', params.endDate);
        }
        if (params.status) {
          searchParams.append('status', params.status);
        }

        return {
          url: `/surveys${searchParams.toString() ? `?${searchParams.toString()}` : ''}`,
          method: 'GET',
        };
      },
      providesTags: (_result, _error, args) => [{ type: 'Surveys', id: `BU-${args.businessUnitId || 'ALL'}` }],
      transformResponse: (response: GetSurveysResponse): GetSurveysResponse => response,
    }),
    getSurveyStats: build.query<SurveyStatsResponse, SurveyStatsParams>({
      query: (params) => ({
        url: '/surveys/stats',
        method: 'POST',
        body: params,
      }),
      providesTags: (_result, _error, args) => [{ type: 'Surveys', id: `STATS-${args.businessUnitId}` }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetSurveysQuery, useLazyGetSurveysQuery, useGetSurveyStatsQuery, useLazyGetSurveyStatsQuery } =
  surveysApi;
